<template>
  <div class="shelves-log">
    <Search ref="search" @search="search"/>
    <Table :list="logList"/>
     <el-pagination
      :style="{ padding: '8px 16px', textAlign: 'right' }"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.pageNo"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    >
    </el-pagination>
    <BulkShelvesResults 
      ref="bulkShelvesResults" 
      @search="search"
      :publishSpeedResult="publishResult" 
      :percentage="publishPercenttage" 
      :pageId="pageId" />
  </div>
</template>

<script>
import Search from './components/search.vue';
import Table from './components/table.vue';
import BulkShelvesResults from '@/components/prod/center/dialogs/bulkShelvesResults.vue';
import { PLATFORM_ICONS_MAP,PLATFORM_NAME_MAP } from '@/dictionary/platforms.js';

import {getProductEditLogPage} from "@/servers/prod/log"
import { mapGetters } from "vuex";

export default {
  components: {
    Search,
    Table,
    BulkShelvesResults
  },
  data() {
    return {
      logList: [],
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    ...mapGetters(['speedResult', 'speedPercentage',"routerPrefix"]),
    pageId() {
      return this.routerPrefix+"log"
    },
    publishResult() {
      return this.speedResult(this.routerPrefix+"log")
    },
    publishPercenttage() {
      return this.speedPercentage(this.routerPrefix+"log")
    }
  },
  methods: {
    search() {
      this.pagination.pageNo = 1;
      this.fetch_log();
    },
    // 分页改变
    handleSizeChange(val) {
      this.pagination.pageNo = 1;
      this.pagination.pageSize = val;
      this.fetch_log();
    },
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.fetch_log();
    },
    async fetch_log() {
      const searchParams = this.$refs.search.method_getSearchForm();
      const {pageNo, pageSize} = this.pagination;
      const _params = {
        ...searchParams,
        pageNo,
        pageSize
      }
      const res = await getProductEditLogPage(_params);
      if(!res) return;
      const {records, total} = res;
      records.forEach(row => {
        row.shopIcon = PLATFORM_ICONS_MAP[row.platform]
        row.platformName = PLATFORM_NAME_MAP[row.platform]
      });
      
      this.logList = records;
      this.pagination.total = total;
    }
  },
  mounted() {
    this.search()
  }

}
</script>

<style lang="scss" scoped>

</style>
